import { Component, OnInit } from '@angular/core';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-rejected-withdrawals',
  templateUrl: './rejected-withdrawals.component.html',
  styleUrls: ['./rejected-withdrawals.component.scss'],
})
export class RejectedWithdrawalsComponent implements OnInit {
  public error = null;
  public rejectedWithdrawals: any[] = [];
  public emailMeDisabled: boolean = false;

  constructor(
    private config: ConfigService,
    private utils: UtilsService,
    private withdrawalService: WithdrawalService) { }

    ngOnInit(){
      this.onGetRejectedWithdrawals();
    }

    onGetRejectedWithdrawals() {
      this.rejectedWithdrawals = [];
      this.withdrawalService.callGetRejectedTransactions().subscribe(
        (response: any) => {
          if (response && !!response.result) {
            var tempTransactions: any = response.payload.rejected_transactions;
            for (let index in tempTransactions) {
              this.rejectedWithdrawals.push(tempTransactions[index]);
            }
          }
        },
        (error) => {
          this.error = error;
        }
      );
    }

    onEmailMeClicked() {
      this.emailMeDisabled = true;
    }
}
